import { Component, Inject, OnInit } from "@angular/core";
import {
	MatLegacyDialogRef as MatDialogRef,
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from "@angular/material/legacy-dialog";

@Component({
	selector: "app-legal-entity-aml-history-dialog",
	templateUrl: "./legal-entity-aml-history-dialog.component.html",
	styleUrls: ["./legal-entity-aml-history-dialog.component.scss"]
})
export class LegalEntityAmlHistoryDialogComponent implements OnInit {
	legalInteityId!: string;

	constructor(
		public dialogRef: MatDialogRef<LegalEntityAmlHistoryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.legalInteityId = this.data;
	}

	closeDialog(): void {
		this.dialogRef.close(false);
	}
}
